import { CurrencyDirection } from "@types";

type CurrencyConfig = {
  symbol: string;
  direction: CurrencyDirection;
};

export const CURRENCY_CONFIGS: Record<string, CurrencyConfig> = {
  THB: { symbol: "฿", direction: CurrencyDirection.SUFFIX },
  PHP: { symbol: "₱", direction: CurrencyDirection.PREFIX },
};
